import { render, staticRenderFns } from "./knowledge-panel.vue?vue&type=template&id=20fec3ba&scoped=true&"
import script from "./knowledge-panel.ts?vue&type=script&lang=ts&"
export * from "./knowledge-panel.ts?vue&type=script&lang=ts&"
import style0 from "./knowledge-panel.scss?vue&type=style&index=0&id=20fec3ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fec3ba",
  null
  
)

export default component.exports